import { CanonicalAction, DataObjectData, DataPointLocation } from '@coac-gmbh/saifty-main-apis'
import { PropertyArray } from '@coac-gmbh/saifty-sap'

export enum ActivityActions {
  Delete = 'DELETE',
  Create = 'CREATE',
  Update = 'UPDATE',
}

export enum ActivityTypes {
  Approval = 'Approval',
  Material = 'Material',
  SAP = 'SAP',
}

export interface BaseActivityLog {
  time: string
  user: string
  action: ActivityActions
}

// We use this local interface to support the old format only to show the old activity logs, but we don't want to use this format in another side
interface OldApprovalFormat {
  data: {
    name: string
    value: string
  }
  provenance: {
    action: CanonicalAction
    confidence: number
  }
  location: DataPointLocation[]
}

export interface ApprovalActivityLog extends BaseActivityLog {
  object: OldApprovalFormat
  objectChanges?: OldApprovalFormat
  type: ActivityTypes.Approval
}

export interface MaterialActivityLog extends BaseActivityLog {
  object: DataObjectData
  objectChanges?: DataObjectData
  type: ActivityTypes.Material
}

export interface SapActivityLog extends BaseActivityLog {
  object: PropertyArray[]
  objectChanges?: PropertyArray[]
  type: ActivityTypes.SAP
  success?: boolean
  errors?: string[]
}

export type ActivityLog = ApprovalActivityLog | MaterialActivityLog | SapActivityLog
